// 14.75 spacing units = 59px (navbar height), 15 = 60px (top/bottom padding).
const wrapperClasses =
    'relative bg-surface ' +
    'min-h-[calc(100vh-calc(var(--spacing)*14.75))] ' +
    'py-[calc(var(--spacing)*15)]';

const SuperAdminPageWrapper = ({ children }) => (
    <section className={wrapperClasses}>
        {children}
    </section>
);

export default SuperAdminPageWrapper;
